<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
	<div class="layout--main" :class="[layoutTypeClass, navbarClasses, footerClasses, {'no-scroll': isAppPage}]">

		<global-filter
			:navbarType="navbarType"
			:navbarColor="navbarColor"
			:footerType="footerType"
			:routerTransition="routerTransition"
			v-if="!disableCustomizer"
			:hideScrollToTop="hideScrollToTop" />

		<v-nav-menu
			:navMenuItems="navMenuItems"
			title="Falcon"
			parent=".layout--main" />

		<div id="content-area" class="invisible" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
			<div id="content-overlay" />

			<!-- Navbar -->
			<template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
			<the-navbar-horizontal
				:navbarType= "navbarType"
				:class="[
				{'text-white' : isNavbarDark  && !isThemeDark},
				{'text-base'  : !isNavbarDark && isThemeDark}
				]" />

			<div style="height: 62px" v-if="navbarType === 'static'"></div>

			<h-nav-menu
				:class="[
				{'text-white' : isNavbarDark  && !isThemeDark},
				{'text-base'  : !isNavbarDark && isThemeDark}
				]"
				:navMenuItems="navMenuItems" />
			</template>

			<template v-else>
			<the-navbar-vertical
				:navbarColor="navbarColor"
				:class="[
				{'text-white' : isNavbarDark  && !isThemeDark},
				{'text-base'  : !isNavbarDark && isThemeDark}
				]" />
			</template>
			<!-- /Navbar -->

			<div class="content-wrapper">

				<div class="router-view">
					<div class="router-content">

						<transition :name="routerTransition">
							<div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center">
								<!-- <div
								class="content-area__heading"
								:class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">
								<h2 class="mb-1">{{ routeTitle }}</h2>
								</div> -->

								<!-- BREADCRUMB -->
								<!-- <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" :route="$route" :isRTL="$vs.rtl" /> -->

								<div class="ml-auto flex flex-wrap items-center justify-between">
									<!-- LISTING COUNT -->
									<!-- TODO: Remove this -->
									<!-- <div class="badge badge--dark mr-4 hidden md:inline-flex" v-if="listingCount['total']">{{ formattedFilteredCount }} / {{ listingCount['total'] | formatNumber }}</div> -->

									<!-- TABLE FILTER DROPDOWN -->
									<!-- TODO: Remove this -->
									<!-- <vs-dropdown v-if="pageButtons['filter'] && user_role == 'admin'" vs-custom-content vs-trigger-click class="mr-4">
										<vx-tooltip text="Quick Filter" position="bottom">
											<vs-button type="border" icon="icon-filter" icon-pack="feather" class="md:block pointer-events-auto"></vs-button>
										</vx-tooltip>

										<vs-dropdown-menu class="mw-full">
											<div class="w-64 p-3 text-center">
												<v-select class="w-full mb-2" placeholder="Select Filter" :value="tableFilterValue" :options="tableFilterOptions" :reset-on-options-change="true" :close-on-select="false" @input="applyFilter"></v-select>
												<vs-button color="dark" type="border" class="block w-full" :disabled="!tableFilterActive" @click="saveFilterPrompt">Save Filter</vs-button>
												<template v-if="pageButtons['blacklist']">
													<hr class="mt-4 mb-3">
													<div class="vx-row text-left">
														<div class="vx-col w-2/3"><span>Keyword Filter</span></div>
														<div class="vx-col w-1/3">
															<vs-switch class="w-full" color="success" v-model="blacklistFilter"></vs-switch>
														</div>
													</div>
												</template>
											</div>
										</vs-dropdown-menu>
									</vs-dropdown> -->

									<!-- BUTTONS -->
									<!-- <div v-if="pageButtons['nonExtendedToggle']" class="nonbutton nonExtendedBtn">
										<div class="form-toggle flex mr-4">
											<vs-switch v-model="switch1" class="nonExtendeToggle">
												<span slot="on"></span>
												<span slot="off"></span>
											</vs-switch>
											<p>Non-Extended</p>
										</div>
									</div> -->
									<!-- TODO:	remove -->
									<!-- <vx-tooltip text="CSV Export" position="bottom" class="mr-4">
										<vs-button v-if="pageButtons['download']" type="border" icon="icon-download" icon-pack="feather" class="md:block" @click="downloadPage()"></vs-button>
									</vx-tooltip>
									<vx-tooltip text="Refresh Table" position="bottom">
										<vs-button v-if="pageButtons['refresh']" type="border" icon="icon-refresh-cw" icon-pack="feather" class="md:block" @click="refreshPage()"></vs-button>
									</vx-tooltip>								 -->
								</div>

							</div>
						</transition>

						<div class="content-area__content">

						<back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500" v-if="!hideScrollToTop">
							<vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />
						</back-to-top>

						<transition :name="routerTransition" mode="out-in">
							<router-view @changeRouteTitle="changeRouteTitle" @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" />
						</transition>
						</div>
					</div>
				</div>
			</div>

			<!-- SAVE TABLE FILTER PROMPT -->
            <vs-prompt vs-title="Enter filter title" :vs-is-valid="tableFilter['title'] != ''" @vs-cancel="tableFilter['title']=''" @vs-accept="saveFilter" :vs-active.sync="tableFilter['prompt']">
                <div class="con-exemple-prompt">
                    <vs-input v-model="tableFilter['title']" class="mt-3 w-full" />
                </div>
            </vs-prompt>
			
			<!-- <the-footer /> -->
		</div>
	</div>
</template>


<script>
import GlobalFilter from "../components/global-filter/GlobalFilter.vue";
import BackToTop from 'vue-backtotop'
import HNavMenu from "@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue"
import navMenuItems from "@/layouts/components/vertical-nav-menu/navMenuItems.js"
import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal.vue'
import TheNavbarVertical from '@/layouts/components/navbar/TheNavbarVertical.vue'
import TheFooter from '@/layouts/components/TheFooter.vue'
import themeConfig from '@/../themeConfig.js'
import VNavMenu from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue'
import vSelect from 'vue-select'

export default {
	components: {
		GlobalFilter,
		BackToTop,
		HNavMenu,
		// TheFooter,
		TheNavbarHorizontal,
		TheNavbarVertical,
		VNavMenu,
		'v-select': vSelect,
	},
	data() {
		return {
			// switch1: false,
			footerType: themeConfig.footerType  || 'static',
			hideScrollToTop: themeConfig.hideScrollToTop,
			isNavbarDark: false,
			navbarColor: themeConfig.navbarColor || '#fff',
			navbarType: themeConfig.navbarType  || 'floating',
			navMenuItems: navMenuItems,
			routerTransition: themeConfig.routerTransition || 'none',
			routeTitle: this.$route.meta.pageTitle,
			disableCustomizer: themeConfig.disableCustomizer,
			tableFilter: {
				title: '',
				prompt: false
			},
			blacklistFilter: false,
		}
	},
	watch: {
		"$route"() {
			this.routeTitle = this.$route.meta.pageTitle
		},
		isThemeDark(val) {
			const color = this.navbarColor == "#fff" && val ? "#10163a" : "#fff"
			this.updateNavbarColor(color)
		},
		"$store.state.mainLayoutType"(val) {
			this.setNavMenuVisibility(val)
		},
		blacklistFilter(val) {
			this.blacklistedFilter(val)
		},
		// switch1(val){
		// 	//var switchValue = this.switch1;
		// 	//console.log('nonExtSwitch', this.switch1)
		// 	this.$root.$emit('nonExtendedPage', val);
		// }
	},
	computed: {
		bodyOverlay() {
			return this.$store.state.bodyOverlay
		},
		contentAreaClass() {
			if(this.mainLayoutType === "vertical") {
				if      (this.verticalNavMenuWidth == "default") return "content-area-reduced"
				else if (this.verticalNavMenuWidth == "reduced") return "content-area-lg"
				else return "content-area-full"
			}
			// else if(this.mainLayoutType === "boxed") return "content-area-reduced"
			else return "content-area-full"
		},
		footerClasses() {
			return {
				'footer-hidden': this.footerType == 'hidden',
				'footer-sticky': this.footerType == 'sticky',
				'footer-static': this.footerType == 'static',
			}
		},
		isAppPage() {
			return this.$route.meta.no_scroll
		},
		isThemeDark() {
			return this.$store.state.theme == 'dark'
		},
		layoutTypeClass() {
			return `main-${this.mainLayoutType}`
		},
		mainLayoutType() {
			return this.$store.state.mainLayoutType
		},
		navbarClasses() {
			return {
				'navbar-hidden'   : this.navbarType == 'hidden',
				'navbar-sticky'   : this.navbarType == 'sticky',
				'navbar-static'   : this.navbarType == 'static',
				'navbar-floating' : this.navbarType == 'floating',
			}
		},
		verticalNavMenuWidth() {
			return this.$store.state.verticalNavMenuWidth
		},
		windowWidth() {
			return this.$store.state.windowWidth
		},
		pageButtons() {
			return {
				refresh: this.$route.meta.buttons ? this.$route.meta.buttons.refresh : false,
				download: this.$route.meta.buttons ? this.$route.meta.buttons.download : false,
				filter: this.$route.meta.buttons ? this.$route.meta.buttons.filter : false,
				blacklist: this.$route.meta.buttons ? this.$route.meta.buttons.blacklist : false,
				nonExtendedToggle: this.$route.meta.buttons ? this.$route.meta.buttons.nonExtendedToggle : false,
			}
		},		
		user_role() {
			return JSON.parse(localStorage.getItem('userDetails')).role;
		},
		listingCount() {
			return this.$store.getters.getListingCount;
		},
		tableFilterValue() {
			return this.$store.getters.getTableFilterValue;
		},
		tableFilterOptions() {
			return this.$store.getters.getTableFilterOptions;
		},
		tableFilterActive() {
			return this.$store.getters.getTableFilterActive;
		},
		formattedFilteredCount() {
			if (this.listingCount['filtered']) {
				let count = this.listingCount['filtered'];

				if(count == 1) {
					return `1`;
				}
				else if((count - 1) % 1000 == 0) {
					return `${this.$options.filters.formatNumber(count - 1)}+`;
				}
				else {
					return this.$options.filters.formatNumber(this.listingCount['filtered']);
				}
			}
			else {
				return 0;
			}
		},
	},
	methods: {
		changeRouteTitle(title) {
			this.routeTitle = title
		},
		updateNavbarColor(val) {
			this.navbarColor = val
			if (val == "#fff") this.isNavbarDark = false
			else this.isNavbarDark = true
		},
		setNavMenuVisibility(layoutType) {
			if((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === "vertical" && this.windowWidth < 1200)) {
				this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
				this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
			}
			else {
				this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
			}
		},
		refreshPage() {
			this.$root.$emit('refreshPage');
			// Clear Table Filter
			this.tableFilter['prompt'] = false;
			this.tableFilter['title'] = '';
			// Reset Blacklist Filter
			this.blacklistFilter = false;
		},
		// nonExtendedSwitch(){
			
		// 	//this. = this.switch1;
		// },
		downloadPage() {
			this.$root.$emit('downloadPage');
		},
		applyFilter(val) {
			this.$store.dispatch('setTableFilterValue', val);
		},
		saveFilterPrompt() {
			this.tableFilter['prompt'] = true;
			this.tableFilter['title'] = '';
		},
		saveFilter() {
			this.$root.$emit('saveFilter', this.tableFilter['title']);
		},
		blacklistedFilter(val) {
			this.$root.$emit('blacklistedFilter', val);
		}
	},
	mounted() {
		if(document.querySelector('#app').classList.contains('window-loaded')) {
			document.getElementById('content-area').classList.remove('invisible');
		} else {
			window.onload = () => {
				document.querySelector('#app').classList.add('window-loaded');
				document.getElementById('content-area').classList.remove('invisible');
			}
		}
	},
	created() {
		const color = this.navbarColor == "#fff" && this.isThemeDark ? "#10163a" : this.navbarColor
		this.updateNavbarColor(color)
		this.setNavMenuVisibility(this.$store.state.mainLayoutType)
	},
}

</script>

